module.exports = __webpack_public_path__ + "img/3-niw-builder.edc0e234.webp";